import { z } from 'zod';
import { FeedbackType } from '../enums.js';

export const sendFeedbackSchema = z.object({
  title: z.string(),
  description: z.string().min(1),
  type: z.enum(FeedbackType),
  isAnonymous: z.boolean(),
});

export type SendFeedbackPayload = z.infer<typeof sendFeedbackSchema>;
